import { useQuery } from '@tanstack/react-query';
import { listLocations, listTasks, listSupplies, upcomingEvents } from '../api/client';
import { useTaps } from './useTaps';

/** Fetch all locations (for full-access users). */
export function useAllLocations() {
  return useQuery({
    queryKey: ['locations', 'all'],
    queryFn: () => listLocations({ includeDeleted: false }),
    staleTime: 5 * 60_000,
  });
}

/** Per-location summary stats for the Leader home cross-location grid. */
export function useLocationSummary(locationId: string) {
  const taps = useTaps(locationId);
  const tasks = useQuery({
    queryKey: ['tasks', locationId, 'open'],
    queryFn: () => listTasks(locationId, { status: 'open', limit: 1 }),
    staleTime: 60_000,
  });
  const supplies = useQuery({
    queryKey: ['supplies', locationId, 'open'],
    queryFn: () =>
      listSupplies(locationId, {
        status: ['requested', 'acknowledged', 'ordered'],
        limit: 1,
      }),
    staleTime: 60_000,
  });
  const events = useQuery({
    queryKey: ['events', 'upcoming', locationId, 7],
    queryFn: () => upcomingEvents(locationId, 7),
    staleTime: 5 * 60_000,
  });

  return {
    tapCount: taps.data?.total ?? null,
    taskCount: tasks.data?.total ?? null,
    supplyCount: supplies.data?.total ?? null,
    eventCount: events.data?.total ?? null,
    isLoading:
      taps.isLoading || tasks.isLoading || supplies.isLoading || events.isLoading,
  };
}
